module.exports = __webpack_public_path__ + "img/img-onnuriorder-quit-02.3188816a.png";